import { render, staticRenderFns } from "./AppointmentEvaluationHistory.vue?vue&type=template&id=706bc6d4&scoped=true"
import script from "./AppointmentEvaluationHistory.vue?vue&type=script&lang=js"
export * from "./AppointmentEvaluationHistory.vue?vue&type=script&lang=js"
import style0 from "./AppointmentEvaluationHistory.vue?vue&type=style&index=0&id=706bc6d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706bc6d4",
  null
  
)

export default component.exports